/* @flow */

import {useMutation} from '@apollo/react-hooks';

import type {
    EmailLeadAssociationsUpdateInput,
    UpdateEmailLeadAssociations as UpdateEmailLeadAssociationsMutation,
    UpdateEmailLeadAssociationsVariables as UpdateEmailLeadAssociationsMutationVariables,
} from 'nutshell-graphql-types';

import EMAIL_FRAGMENT_SPARSE from '../graphql/fragments/sparse/email-fragment-sparse.graphql';
import UPDATE_EMAIL_LEAD_ASSOCIATIONS from './graphql/mutations/update-email-lead-associations.graphql';

export function useUpdateEmailLeadAssociations(): (EmailLeadAssociationsUpdateInput) => Promise<*> {
    const [updateEmailLeadAssociations] = useMutation<
        UpdateEmailLeadAssociationsMutation,
        UpdateEmailLeadAssociationsMutationVariables
    >(UPDATE_EMAIL_LEAD_ASSOCIATIONS);

    return (input: EmailLeadAssociationsUpdateInput) =>
        updateEmailLeadAssociations({
            variables: {input},
            update: (proxy) => {
                const emailFragment = proxy.readFragment({
                    id: input.emailId,
                    fragmentName: 'EmailFragmentSparse',
                    fragment: EMAIL_FRAGMENT_SPARSE,
                });

                if (emailFragment) {
                    const updatedEmailRelatedLeads = {...emailFragment.emailRelatedLeads};

                    input.leadAssociations.forEach((updatedAssociation) => {
                        const associationIndex = updatedEmailRelatedLeads.edges.findIndex(
                            (leadEdge) => updatedAssociation.leadId === leadEdge.node.id
                        );

                        if (associationIndex !== -1) {
                            updatedEmailRelatedLeads.edges[associationIndex].isMapped =
                                updatedAssociation.isMapped;
                        }
                    });

                    proxy.writeFragment({
                        id: input.emailId,
                        fragmentName: 'EmailFragmentSparse',
                        fragment: EMAIL_FRAGMENT_SPARSE,
                        data: {
                            ...emailFragment,
                            emailRelatedLeads: {...updatedEmailRelatedLeads},
                        },
                    });
                }
            },
        });
}
